import React, { useState } from "react";
import { message } from "antd";
import Layout from "../../components/Layout";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import GlassCard from "../../components/premium/GlassCard";
import CampaignForm from "./CampaignForm";
import { createCampaign } from "../../services/campaign/campaignServices";
import slugs from "../../resources/slugs";

const CreateCampaign = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await createCampaign(values);
      if (res?.success) {
        message.success("Campaign created successfully");
        navigate(slugs.campaigns);
      } else {
        message.error(res?.message || "Failed to create campaign");
      }
    } catch (error) {
      message.error("An error occurred while creating the campaign");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="create-campaign-container">
        <div 
          style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px", cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          <ArrowLeftOutlined />
          <h2 style={{ margin: 0 }}>Create New Campaign</h2>
        </div>

        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <GlassCard padding="40px">
            <p style={{ marginBottom: "32px", color: "var(--text-muted)" }}>
              Fill in the details below to launch a new marketing campaign or push notification.
            </p>
            <CampaignForm onFinish={onFinish} loading={loading} btnText="Launch Campaign" />
          </GlassCard>
        </div>
      </div>
    </Layout>
  );
};

export default CreateCampaign;
